import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/uxui-improvement/Template'
import { caseStudyItems } from 'components/cases/Case/CaseStudyItem'
import { categoryTitle } from 'components/cases/listpage/uxui-improvement/Template'

const UXUIImprovement: React.FC<{ pageId: number }> = ({ pageId }) => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])

  return (
    <>
      <CustomHead
        keyword={'事例 実績 UX/UI 顧客体験 OOUI ユーザーリサーチ ペルソナ カスタマージャーニーマップ'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={`https://aitria.co.jp/cases/uxui-improvement/page/${pageId}/`}
        title={`UX/UIデザイン | 事例 | Aitria（アイトリア）`}
        description="UX/UIデザインサービスのケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={pageId} />
    </>
  )
}

export async function getStaticPaths() {
  const filteredItems = caseStudyItems.filter(
    (item) => item.tags.some((tag) => tag.tag === categoryTitle), // tags の中に categoryTitle が含まれているかチェック
  )
  const totalItems = filteredItems.length
  const pageSize = 10
  const totalPages = Math.ceil(totalItems / pageSize)

  const paths = Array.from({ length: totalPages }, (_, i) => ({
    params: { id: (i + 1).toString() },
  }))

  return { paths, fallback: false }
}

export async function getStaticProps({ params }) {
  const pageId = parseInt(params.id, 10)

  return {
    props: { pageId },
  }
}

export default UXUIImprovement
